import api from '@/services/api'

const defaultevents = {
	'2019-11-11': [
		{
			id: 'e4',
			start: '2019-11-11 10:00',
			duration: 60,
			state: 'new',
			title: 'Event 1111',
			color: '#eee',
			client: {
				name: 'mon client',
				address: 'zare ouest',
				zipcode: '4384',
				city: 'Ehlerange',
				email: 'contact@cosnelio.oicm',
				phone: '0303030303'
			},
			actions: [
				{
					name: 'intervention',
					form_id: 'INF-A7-1-TCOX4',
					status: 'end'
				}
			],
			showactions: false
		}
	]
};

export default {
	namespaced: true,
	state: {
		events: null,
	},
	mutations: {
		setevents(state, events) {
			state.events = events
		},
	},
	actions: {
		async refresh({commit, state, dispatch}, calid) {
			if (!calid){
				return
			}
			try {
				let call = await api.get({token: null, url: 'intervention/AFCO/missions/'+calid})
				
				let events = call.response;
				Object.keys(events).map(function(date, index) {
					Object.keys(events[date]).map(function(key) {
						events[date][key]['end'] = moment(events[date][key].start).add(events[date][key].duration, 'm').format('YYYY-MM-DD HH:mm:ss');
					})
				})
				
				commit('setevents', events);
			} catch (err) {
				console.log('forms refresh', err);
				commit('setevents', []);
			}
		}
	},
	getters: {
		getEvents: (state) => {
			return state.events;
		},
		getAllUid: (state) => {
			let events = state.events;
			let ids = [];
			Object.keys(events).forEach(date => {
				events[date].forEach(e => {
					ids.push(e.uid);
				})
			});
			return ids;
		},
		getEvent: (state) => (id) => {
			let events = state.events;
			let event;
			Object.keys(events).forEach(date => {
				if (!event) {
					event = events[date].find(evt => evt.uid == id);
				}
			});
			return event;
		}
	}
}
